import { typeSafeObjectKeys } from './typeSafeObjectKeys';

export const formatSellerType = (
  isTrader: boolean,
  /**
   * This object has optional keys because it is what the BE returns and this makes it
   * easier to use.
   */
  verification: { email?: boolean; phone?: boolean; bank?: boolean },
  sellerType: string | null,
): string | undefined => {
  if (verification && typeSafeObjectKeys(verification).length > 0) {
    const { email, phone, bank } = verification;
    if (email && phone && bank) {
      if (isTrader) {
        return 'Verified Trader';
      } else if (sellerType === 'PRIVATE') {
        return 'Verified Private Seller';
      } else {
        return undefined;
      }
    } else {
      if (isTrader) {
        return 'Trader';
      } else if (sellerType === 'PRIVATE') {
        return 'Private Seller';
      } else {
        return undefined;
      }
    }
  }
  return undefined;
};
